import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ContentContainerThemeFragment: GraphQLTaggedNode = graphql`
	fragment ContentContainerTheme_space on Space {
		theme {
			name
			themeKey
		}
		lookAndFeel {
			content {
				screen {
					background
					backgroundColor
					backgroundImage
					backgroundPosition
					backgroundSize
					backgroundRepeat
					backgroundOrigin
					backgroundClip
					backgroundAttachment
					backgroundBlendMode
					layer {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						width
						height
					}
					gutterTop
					gutterRight
					gutterBottom
					gutterLeft
				}
				container {
					background
					backgroundColor
					backgroundImage
					backgroundPosition
					backgroundSize
					backgroundRepeat
					backgroundOrigin
					backgroundClip
					backgroundAttachment
					backgroundBlendMode
					padding
					borderRadius
				}
			}
		}
	}
`;
